import { useContext } from 'react';
import { ColumnContext } from '../contexts/column.context';

export const useColumn = () => {
  const context = useContext(ColumnContext);
  if (context == null) {
    throw new Error('useColumn must be used inside <Column />');
  }

  return context;
};
